// SftpPage.js
import React from 'react';
import { Box, Typography, Paper } from '@mui/material';
import SftpManager from './SftpManager';
import { useAuth } from '../../../context/AuthContext';


const SftpPage = () => {
  const { authData } = useAuth();

  if (!authData || !authData.is_staff) {
    return (
      <Box sx={{ mt: 6 }}>
        <h3>You do not have permission to EHS SFTP.</h3>
      </Box>
    );
  }

  return (
    <Box component="main" sx={{ mt: 4 }}>
      <Box
        sx={{
          backgroundColor: '#f9f9f9',
          padding: 3,
          borderRadius: 2,
          boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
          marginTop: '50px',
          marginBottom: 4,
          textAlign: 'center',
          transition: 'transform 0.3s ease, boxShadow 0.3s ease',
          '&:hover': {
            transform: 'translateY(-8px)',
            boxShadow: '0 8px 16px rgba(0, 0, 0, 0.2)',
          },
        }}
      >
        <Paper sx={{ padding: 3 }}>
          <SftpManager />
        </Paper>
      </Box>
    </Box>
  );
};

export default SftpPage;